// extracted by mini-css-extract-plugin
module.exports = {"carouselItem":"styles_carouselItem__DTu7p","container":"styles_container__dAkP4"};